import { render, staticRenderFns } from "./RedactionDashboard.vue?vue&type=template&id=d98eaca8&scoped=true"
import script from "./RedactionDashboard.vue?vue&type=script&lang=ts"
export * from "./RedactionDashboard.vue?vue&type=script&lang=ts"
import style0 from "./RedactionDashboard.scss?vue&type=style&index=0&id=d98eaca8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98eaca8",
  null
  
)

export default component.exports